<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <!-- Breadcrumb Section -->
                    <div class="breadcrumbactive">
                        <div>
                            <span class="pointer" @click="rediectList()">Customer</span>
                            <div v-if="!EditCustomerButton">Archive</div>
                            <div>{{ this.$route.params.id == 'new' ? 'Create Customer' : 'View Customer'}}</div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center" v-if="customer_info">
                        <!-- v-if="userPermissions.customers.edit" -->
                        <button v-if="EditCustomerButton" class="btn btn-des-small mt-2 mr-3 new-field-btn d-block ml-auto mb-3"  @click="addAssociatedContact('add')" :disabled="hideAddContactButton || added_contact.length > 4">+Additional Contact</button>
                        <button v-if="EditCustomerButton" class="btn btn-des-small mt-2 ml-3 new-field-btn d-block ml-auto mb-3"  @click="editCustomer()">Edit</button>
                    </div>
                </div>
            </h2>
            <!-- <div class="d-flex">
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'customer_info','new-blue':active_tab == 'customer_info'}" @click="switchTabs('customer_info')">
                    <span class="text-capitalize">Customer Info</span>
                </div>
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'consultation','new-blue':active_tab == 'consultation'}" @click="switchTabs('consultation')">
                    <span class="text-capitalize">Interaction</span>
                </div>
                <div class='slant-tabs' :class="{'activeTab':active_tab == 'interaction_details','new-blue':active_tab == 'interaction_details'}" @click="switchTabs('interaction_details')">
                    <span class="text-capitalize">Activity Log</span>
                </div>
            </div> -->
            <!-- Tabs Section -->
            <div class="tabs tabs-style-shape">
                <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                    </defs>
                </svg>
                <nav>
                    <ul class="ml-0">
                        <li :class="{'tab-current':active_tab == 'customer_info'}">
                            <a href="javascript:;" @click="switchTabs('customer_info')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span>Customer Info</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'consultation'}">
                            <a href="javascript:;" @click="switchTabs('consultation')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Interaction</span>
                            </a>
                        </li>
                        <li :class="{'tab-current':active_tab == 'interaction_details'}">
                            <a href="javascript:;" @click="switchTabs('interaction_details')" style="text-decoration: none !important;">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                <span style="border-radius: 30px 0 0 0;">Activity Log</span>
                            </a>
                        </li>
                        <!-- For styling we need this tag  -->
                        <li style="width: 0px !important;flex: 0 !important;">
                            <a href="#section-shape-3" style="margin: 0">
                                <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <customer-info v-if="customer_info"></customer-info>
            <customer-consultation v-if="consultation"></customer-consultation>
            <customer-interactions v-if="interaction_details"></customer-interactions>
        </div>
        <associated-contact :view_mode="view_mode" :added_contact="added_contact" :customer_id="customer_id" v-if="add_associated_contact" modal_name="addAssociatedContact"
        @hideAssociatedContact="hideAssociatedContact" @saveAssociatedContact="saveAssociatedContact"></associated-contact>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event.js';
import { HalfCircleSpinner } from "epic-spinners";
import customer from '../mixins/customer';
import convert from '../mixins/convert';
const CustomerInfo = () => import("./CustomerInfo")
const CustomerConsultation = () => import('./CustomerConsultation')
const CustomerInteractions = () => import('./CustomerInteractions')
const AssociatedContact = () => import("./AddAssociatedContact.vue");
export default {
    data(){
        return {
            subsidiary_company_id:'',
            ajaxCallInProgress: false,
            show_customer_details: true,
            customer_details: null,
            customer_branches:null,
            show_company_address: true,
            date_iso: false,
            date: new Date(),
            formatted_date: null,
            formatted_time: new Date(),
            EditCustomerButton : true,
            contact_tab: true,
            add_info_tab: true,
            action_logs: [],
            interested_product_name: null,
            selected_customer: null,
            show_action_log: true,
            active_tab: 'customer_info',
            customer_info: true,
            consultation: false,
            interaction_details: false,
            add_associated_contact: false,
            hideAddContactButton: false,
            view_mode: "",
            customer_id: "",
            added_contact: []
        }
    },
    mixins:[customer,convert],
    components:{
        HalfCircleSpinner,
        CustomerInfo,
        CustomerConsultation,
        CustomerInteractions,
        AssociatedContact
    },
    methods:{
        async loadCustomerDetails() {
            let response = await this.getCustomerDetails(this.$route.params.id)
            let customer_branches = response.response
            this.added_contact = customer_branches.associated_contacts
            this.ajaxCallInProgress = false
        },
        hideAssociatedContact() {
            this.add_associated_contact = false
            this.loadCustomerDetails()
        },
        addAssociatedContact(mode) {
            this.customer_id = this.$route.params.id
            if(mode == 'add'){
                this.hideAddContactButton = true;
            }
            this.view_mode = 'view'
            this.added_contact = []
            this.add_associated_contact = true
            setTimeout(() => {
                this.hideAddContactButton = false;
                this.$modal.show("addAssociatedContact");
            }, 500);
        },
        saveAssociatedContact(){
            this.customer_info = true
            EventBus.$emit('loadingCustomerDetails');
        },
        //swtich the tabs between customer info/consultation/interaction details
        /**@params = obj */
        switchTabs (obj){
            if(obj == 'customer_info'){
                this.active_tab = 'customer_info'
                this.customer_info = true
                this.consultation = false
                this.interaction_details = false
            }
            else if(obj == 'consultation'){
                this.active_tab = 'consultation'
                this.customer_info = false
                this.consultation = true
                this.interaction_details = false
            }
            else if(obj == 'interaction_details'){
                this.active_tab = 'interaction_details'
                this.customer_info = false
                this.consultation = false
                this.interaction_details = true
            }
        },
        //Redirecting to the customer list view
        rediectList(){
            this.$router.push("/customerlist")
        },
        //show/hide the action log table
        showActionLog(){
            this.show_action_log = !this.show_action_log
        },
        //Show the branch address modal
        showBranchInfo(value){
            this.selected_customer = value
            setTimeout(() => {
                this.$modal.show("view-branch-address")
            },500)
        },
        //show/hide the POC details
        showPointofContact() {
            this.contact_tab = !this.contact_tab
        },
        //Redirecting to the edit customer 
        editCustomer(){
            let id = this.$route.params.id
            this.$router.push('/edit_customer/' + id);
        },
        //showing the selected contacts
        selectedContacts(){
            this.$emit("selectContacts")
        },
        //show/hide the company address
        showCompanyAddress(){
            this.show_company_address = !this.show_company_address
        },
        //show/hide the customer info
        showCustomerInfo() {
            this.show_customer_details = !this.show_customer_details
        },
        //show/hide the additional info
        showAddInfo() {
            this.add_info_tab = !this.add_info_tab
        },
        //API call of customer action log
        // async loadActionLog(){
        //     this.action_logs = []
        //     let params = {
        //         skip: 0,
        //         limit: 50,
        //         id: this.$route.params.id
        //     }
        //     let response = await this.getCustomerActionLog(params);
        //     this.action_logs = response.response
        // }
    },
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
    },
    mounted() {
        EventBus.$on("delteAssoConatct", () =>{
            this.loadCustomerDetails();
        })
        this.loadCustomerDetails();
        let tabView = localStorage.getItem('TabActive')
        if(tabView == 'Archive'){
            this.EditCustomerButton = false
        }
        //this.loadActionLog();
    }
}
</script>
<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .map-location {
        cursor:pointer;
        height: 48px;
        padding-top: 7px;
    }
    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .overflow-auto {
        overflow: auto;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 10px;
        font-size: 14px;
    }
    .new-field-btn{
        color: #fff;
        background-color: #008a63;
    }

    .input-field {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
    }

    .input-width {
        border-radius: 8px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;

        height: 48px !important;
    }

    .input-field-length {
        opacity: 0.5;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 0.3px;
        color: #000;
    }

    .btn-new-cancel {
        color: #005dae;
        background-color: #fff;
        border-radius: 5px;
        text-transform: none;
        font-weight: 500;
        border: 2px solid #005dae;
        line-height: 30px;
        box-shadow: none;
    }
    .btn-new-save {
        border: 2px solid #005dae;
        line-height: 30px;
        border-radius: 5px;
    }
    .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
        height: 32px !important;
        color: #fff !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }

    .mx-input {
        /* border-bottom: 1px solid #fff !important; */
        display: inline-block;
        height: 0px !important;
    }
    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #448e4d !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .input-date-position{
        position: relative;
        bottom: 7px;
    }
    .remainder-list{
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px;
        height:100px
    }
    .action-log-list{
        box-shadow: 0 0 3px 0 #939393;
        border: solid 1px #939393;
        border-radius: 6px;
        padding: 7px 20px;
        height:200px;
    }
     .new-field-btn{
         color: #fff;
         background-color: #008a63;
     }
 
     .input-field {
         border-radius: 8px !important;
         border: solid 0.5px #3f3f3f;
         background-color: #fff;
         padding: 8px 10px;
         width: 100% !important;
         height: 40px;
     }
 
     .input-width {
         border-radius: 8px !important;
         border: solid 0.5px #3f3f3f;
         background-color: #fff;
         padding: 8px 10px;
         width: 100% !important;
 
         height: 48px !important;
     }
 
     .input-field-length {
         opacity: 0.5;
         font-size: 13px;
         font-weight: normal;
         font-stretch: normal;
         font-style: normal;
         line-height: 1.5;
         letter-spacing: 0.3px;
         color: #000;
     }
 
     .btn-new-cancel {
         color: #005dae;
         background-color: #fff;
         border-radius: 5px;
         text-transform: none;
         font-weight: 500;
         border: 2px solid #005dae;
         line-height: 30px;
         box-shadow: none;
     }
     .btn-new-save {
         border: 2px solid #005dae;
         line-height: 30px;
         border-radius: 5px;
     }
     .mx-datepicker.date-white .mx-input-wrapper input.mx-input {
         height: 32px !important;
         color: #fff !important;
         font-weight: 600 !important;
         font-size: 13px !important;
     }
 
     .mx-input {
         /* border-bottom: 1px solid #fff !important; */
         display: inline-block;
         height: 0px !important;
     }
     i,
     [class^="icon-"] {
         line-height: 0px !important;
     }
     .text-green {
         color: #448e4d !important;
     }
     .pointer-event {
         background-color: #fff !important;
     }
     .input-date-position{
         position: relative;
         bottom: 7px;
     }
     .remainder-list{
         box-shadow: 0 0 3px 0 #939393;
         border: solid 1px #939393;
         border-radius: 6px;
         padding: 7px;
         height:100px
     }
     .action-log-list{
         box-shadow: 0 0 3px 0 #939393;
         border: solid 1px #939393;
         border-radius: 6px;
         padding: 7px 20px;
         height:200px;
     }
      .new-field-btn{
         color: #fff;
         background-color: #00448b;
     }
     .address-card-height {
         overflow-y: scroll;
         overflow-x: scroll;
         max-height: 230px;
         min-height:160px;
     }
     .header-outer {
         width: 100%;
         background: #005dae;
         color: #fff;
         font-size: 14px;
         padding-top: 10px;
         padding-bottom: 10px;
         padding-right: 20px;
         padding-left: 80px;
         display: flex;
         justify-content: space-between;
         align-items: center;
     }
     .view-contact-tab {
         padding :10px 20px 10px 20px;
     }
     .overflow-auto{
         overflow: auto;
     }
     .table-properties{
         border-collapse: collapse;
         width:100%;
     }
     .action_log thead th{
         color: #005dae;
     }
     table thead th,
     table tbody td{
         padding:5px;
     }
     .table-align {
         width: 33%;
         text-align: center;
     }
 </style>
 


// WEBPACK FOOTER //
// src/components/Customers/ViewCustomer.vue